<div class="modal-header align-items-start">
  <div class="d-flex flex-column">
    <h5 class="modal-title mb-1">
      <i class="fa fa-comments me-2"></i>
      {{ 'sendMessage.title' | translate }}
    </h5>
    <p class="text-muted small mb-0">{{ 'sendMessage.requiredFields' | translate }}</p>
  </div>
  <button type="button" class="btn-close" (click)="close()"></button>
</div>

<div class="modal-body">
  @if (company) {
    <div class="event-info-banner mb-4">
      <div class="event-name">
        <i class="fa fa-building me-2"></i>
        {{ company.company_name }}
      </div>
      @if (company.city || company.country) {
        <div class="company-name text-muted">
          <i class="fa fa-location-dot me-2"></i>
          {{ company.city }}{{ company.city && company.country ? ', ' : '' }}{{ company.country }}
        </div>
      }
    </div>
  } @else if (event) {
    <div class="event-info-banner mb-4">
      <div class="event-name">
        <i class="fa fa-calendar me-2"></i>
        {{ event.event_name }}
      </div>
      @if (event.company) {
        <div class="company-name text-muted">
          <i class="fa fa-building me-2"></i>
          {{ event.company.company_name }}
        </div>
      }
    </div>
  }

  <div class="form-group mb-4">
    <label class="form-label">{{ 'sendMessage.subjectOptional' | translate }}</label>
    <input
      type="text"
      class="form-control"
      [(ngModel)]="subject"
      [placeholder]="'sendMessage.subjectPlaceholder' | translate"
    />
  </div>

  <div class="form-group mb-4">
    <label class="form-label">{{ 'sendMessage.yourMessage' | translate }} <span class="text-danger">*</span></label>
    <textarea
      class="form-control"
      [class.is-invalid]="isMessageInvalid"
      [(ngModel)]="messageText"
      rows="5"
      [placeholder]="'sendMessage.messagePlaceholder' | translate"
      [disabled]="isSending"
    ></textarea>
    @if (isMessageInvalid) {
      <div class="invalid-feedback">{{ 'sendMessage.messageRequired' | translate }}</div>
    }
  </div>

  @if (errorMessage) {
    <div class="alert alert-danger">
      <i class="fa fa-exclamation-circle me-2"></i>
      {{ errorMessage }}
    </div>
  }
</div>

<div class="modal-footer">
  <button type="button" class="btn btn-light" (click)="close()" [disabled]="isSending">
    {{ 'common.cancel' | translate }}
  </button>
  <button
    type="button"
    class="btn btn-primary"
    (click)="sendMessage()"
    [disabled]="isSending"
  >
    @if (isSending) {
      <i class="fa fa-spinner fa-spin me-2"></i>
      {{ 'sendMessage.sending' | translate }}
    } @else {
      <i class="fa fa-paper-plane me-2"></i>
      {{ 'sendMessage.sendMessage' | translate }}
    }
  </button>
</div>
